export const ORDER_STATUS = {
  pending_payment: "Awaiting Payment",
  paid: "Payment Received",
  processing: "Preparing",
  shipped: "Shipped",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered",
  cancelled: "Cancelled",
  payment_failed: "Payment Failed",
  return_requested: "Return Requested",
  return_approved: "Return Approved",
  return_rejected: "Return Rejected",
  returned: "Returned",
};

export const statusLabel = (s) => ORDER_STATUS[s] || s?.replace(/_/g, " ") || "—";
